import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getTeacherAlreadyWithdrawn, getTeacherWallet } from "../../../../../store/actions/teacher";
import { useWindowDimensions } from "../../../../../utils/util";
import { toast } from "react-toastify";
import WithDrawModal from "../Modals/WithDrawModal";
import { formatCurrency } from "../../../../../utils/currency";
import styles from "../styles.module.css";

const WithdrawalStatus = ({ teacherData, handleWithdrawals, handlePending }) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [teacherWallet, setTeacherWallet] = useState({});
  const [alreadyWithdrawn, setAlreadyWithdrawn] = useState(0);

  const getWallet = useCallback(async () => {
    const data = await dispatch(getTeacherWallet());
    if (data?.success) setTeacherWallet(data.data);
  }, [dispatch]);

  const getAlreadyWithdrawn = useCallback(async () => {
    const data = await dispatch(getTeacherAlreadyWithdrawn());
    if (data?.success) setAlreadyWithdrawn(data.data);
  }, [dispatch]);

  useEffect(() => { getWallet(); getAlreadyWithdrawn(); }, [getWallet, getAlreadyWithdrawn]);

  return (
    <>
      {withdrawModal && <WithDrawModal
        setEditModal={setWithdrawModal}
        width={width}
        teacherData={teacherData}
        teacherWallet={teacherWallet}
        getWallet={getWallet}
        handleWithdrawals={handleWithdrawals}
        handlePending={handlePending}
      />}
      <div className={styles.myEarnings}>
        <div className={styles.secondRowHeadings}>Withdrawals</div>
        <div className={styles.earningsRow}>
          <div className={styles.earningsBlock}>
            <p className={styles.earningsTitle}>Already Withdrawn</p>
            <p className={styles.earningsValue}>{formatCurrency(alreadyWithdrawn)}</p>
          </div>
          <div className={styles.earningsBlock}>
            <p className={styles.earningsTitle}>Available to Withdraw</p>
            <p className={styles.earningsValue}>{formatCurrency(teacherWallet?.balanceAmount || 0)}</p>
          </div>
          <div className={styles.earningsBlock}>
            <p className={styles.earningsTitle}>Est. Net Payout (after 21% fee)</p>
            <p className={styles.earningsValue} style={{ color: "#5cb85c" }}>{formatCurrency((Number(teacherWallet?.balanceAmount || 0) * 0.79))}</p>
          </div>
        </div>
        <div className={styles.withdrawSection}>
          <div className={styles.withdrawBtn}
            onClick={() => {
              if (teacherWallet?.balanceAmount < 50) return toast.warning("Your wallet should have above ₹50 before withdrawal");
              setWithdrawModal(true);
            }}>
            Withdraw
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalStatus;
